/**
 * @file handle sidebar elements
 * @author tobias.frei@notch-interactive.com
 *
 * @module modules/m16-sidebar.js
 *
 */

/* Imports */
import helperDom from '../helpers/helper-dom.js';

const instance = {},

    /**
     * Object with default values.
     * This values can be overridden by passing an options object when creating a knob instance.
     *
     * @typedef defaults
     */
    defaults = {
        mainElement: '.m-sidebar',
        hooks: {
            navtrigger: '[data-sidebarnav-trigger]'
        },
        states: {
            active: 'is-open'
        }
    };


/* private variables */
let settings,
    sidebarModule,
    navTriggers,

    /* private methods */
    bindEvents = () => {
        // bind click triggers to nav items
        navTriggers.forEach((navTrigger) => {
            navTrigger.addEventListener('click', triggerNavEvent, false);
        });
    },
    unbindEvents = () => {
        navTriggers.forEach((navTrigger) => {
            navTrigger.removeEventListener('click', triggerNavEvent);
        });
    },
    triggerNavEvent = (e) => {
        e.preventDefault();
        // get element from target
        let el = e.target.correspondingUseElement || e.target || e.srcElement,
            nav = helperDom.nextSibling(el, 'sidebarnav');

        if (el.classList.contains(settings.states.active)) {
            // close
            el.classList.remove(settings.states.active);
            nav.style.height = '0';
        } else {
            // open
            el.classList.add(settings.states.active);
            console.log(nav.children[0]);

            nav.style.height = nav.children[0].offsetHeight + 'px';
        }
    };


/* public methods */

/**
 * Initialize module
 *
 * @param {object=} options - Override default settings with options object.
 * @param {string=} options.mainElement - The query selector of the main sidebar module.
 * @param {object=} options.hooks - The settings for all hooks.
 * @param {string=} options.hooks.navtrigger - The query selector for mobile navigation trigger.
 * @param {object=} options.states - The classes of the switch states.
 * @param {string=} options.states.active - The classname of the active item state.
 * @return {object} Instance of created module.
 */
instance.init = (options) => {
    settings = Object.assign({}, defaults, options);

    // get module element
    sidebarModule = document.querySelector(settings.mainElement);
    if (!sidebarModule) {
        return;
    }

    // get triggers for accordion navs
    navTriggers = [...sidebarModule.querySelectorAll(settings.hooks.navtrigger)];

    // bind triggers to event
    bindEvents();

    return instance;
};

/**
 * Destroy this module.
 * Unbind events, remove dom classes, etc...
 */
instance.destroy = () => {
    unbindEvents();
};

export default instance;
